import { Models } from "@hex-insights/app-modules";
import { dateDiff, dateTrunc, stringToLocalDate, toGrammaticalNumber } from "@hex-insights/core";
import { EnrollmentApplicationStudent, EnrollmentApplicationStudentNameFragment } from "../../../Utilities";
import { EnrollmentApplicationStudentUtilities } from "../../Utilities";
import * as PersonFormat from "../Person";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: EnrollmentApplicationStudentNameFragment) {
	return Fields.name(instance.name);
}

export function nameFromFields(
	instance: Pick<EnrollmentApplicationStudent, "givenName" | "familyName"> & {
		nameOrder: EnrollmentApplicationStudent["nameOrder"] | null;
	},
) {
	return PersonFormat.nameFromFields({
		...instance,
		nameOrder: EnrollmentApplicationStudentUtilities.nameOrderToPersonNameOrder(instance.nameOrder),
		nickname: "",
	});
}

/**
 * Formats the age the student given their date of birth
 */
export function age(dob: EnrollmentApplicationStudent["dateOfBirth"] | null) {
	if (dob === null) {
		return Models.toString(dob);
	}
	const years = dateDiff(dateTrunc(new Date(), "day"), stringToLocalDate(dob, "day"), "year");
	return `${toGrammaticalNumber("year", years, true)} old`;
}

export function possessivePronoun(gender: EnrollmentApplicationStudent["gender"]) {
	if (gender === "Male") {
		return "his";
	}
	if (gender === "Female") {
		return "her";
	}
	return "their";
}
